const RESOURCE_TYPE_STATS = {
  ASSIGNMENT: "assignment",
  ASSESSMENT: "assessment",
  WORKSHEET: "worksheet",
  INFOSHEET: "infosheet",
  LINK: "link",
  FILE: "file",
};

const resourceTypeOptions = [
  { value: "all", label: "All Assignments" },
  { value: "assessment", label: "Assessments" },
  { value: "worksheet", label: "Worksheets" },
  { value: "infosheet", label: "Infosheets" },
  { value: "linkFile", label: "Links and Files" },
];

export { RESOURCE_TYPE_STATS, resourceTypeOptions };
